import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import OrderHeadSectionComponent from "../../../../components/headSection/components/OrderHeadSectionComponent";
import OrderMainFoodPath from '../../../orderMainFoodSection/components/OrderMainFoodPath';
import SearchedRealatedProduct from "../SearchedRealatedProduct";
import ContactSectionComponent from '../../../../pages/main/sections/contactSection/ContactSectionComponent';
import OrderMainAcceptedDetails from "./OrderMainAcceptedDetails";
import { UseGetReservationsById } from "../../../../api/useReservation";
import { useSelector } from "react-redux";

const getCategoryName = (category: string) => {
    const words = category.split("-");
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase() + words[0].slice(1);
    } else {
        const firstWord = words[0];
        const restOfWords = words.slice(1).join(" ");
        return firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + " " + restOfWords;
    }
}

const OrderMainAcceptedSectionComponent = () => {
    const user = useSelector((state: any) => state.user);
    const {category, details, order} = useParams();
    const [selectedOrder, setSelectedOrder] = useState<any>({});
    
    useEffect(() => {
        if (user && details) {
            UseGetReservationsById(details).then((response: any) => {
                console.log("UseGetReservationsById response: ", response);
                if (response && response.status === 200) {
                    const fetchedData = response.result;
                    
                    console.log("Fetched: ", fetchedData);
                    setSelectedOrder(fetchedData);
                    
                    /*const categoriesMap = new Map<string, any[]>();
				
										// fetchedData.length > 0 && setSelectedCategory(fetchedData[0]?.category);
				
										fetchedData && fetchedData.length > 0 && fetchedData.forEach((item: any) => {
											if (item && item.data.isActivated) {
												if (item.data.validUntilTime !== null) {
													const validUntilTime = new Date();
													const [hours, minutes] = item.data.validUntilTime.split(":");
													validUntilTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0);
				
													const currentTime = new Date();
				
													if (currentTime > validUntilTime) {
														// return;
													}
												}
				
												item.category.forEach((category: string) => {
													const normalizedCategory = category.toLowerCase();
													if (!categoriesMap.has(normalizedCategory)) {
														categoriesMap.set(normalizedCategory, []);
													}
													categoriesMap.get(normalizedCategory)!.push(item);
												});
											}
										});
										Array.from(categoriesMap.keys()).length > 0 && Array.from(categoriesMap.keys()).map((category, index) => {
											index === 0 && setSelectedCategory(category);
											// setSelectedCategory()
										});
										setCategoriesMap(categoriesMap);*/
                }
            });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [user]);
    
    return (
        <>
            <OrderHeadSectionComponent />
            <div className="orderMainSectionComponent__container">
                {/*<OrderMainFoodPath
                  path={["Food", category ? getCategoryName(category) : "", details ? getCategoryName(details) : ""]}
                  selectedCategory={category ? getCategoryName(category) : ""}
                />*/}
                <OrderMainFoodPath
                  path={["Cart"]}
                  selectedCategory={details ? getCategoryName(details) : ""}
                />
                {
                    selectedOrder && selectedOrder.reservation && (
                    <OrderMainAcceptedDetails
                      selectedOrder={selectedOrder}
                    />
                  )
                }
                
                <div className="orderMainSectionComponent__container-content-searched-realated-product">
                    <SearchedRealatedProduct />
                </div>
                <div className="orderMainSectionComponent__container-content-contact">
                    <ContactSectionComponent />
                </div>
            </div>
        </>
    );
};

export default OrderMainAcceptedSectionComponent;